/**
 * Builds the toolbar control that shows or hides the template keys panel.
 * A text button on purpose: Jodit hides the text as soon as an icon is set,
 * and this control sits first in the toolbar to be found at a glance.
 * @function
 *
 * @param {Function} t - The i18next translation function.
 * @param {Function} onToggle - Called on each click to show or hide the panel.
 * @returns {Object} The Jodit control.
 */
export const templateKeysButton = (t, onToggle) => ({
  name: 'templateKeys',
  text: t('template-documents.keys_panel.button'),
  tooltip: t('template-documents.keys_panel.tooltip'),
  exec: () => {
    onToggle();
    // Tells Jodit the command is handled: no value synchronisation, no popup
    // closing on its side.
    return true;
  }
});
